import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import ProjectDetails from "../../components/ProjectDetails/ProjectDetails";
import MainNav from "../../shared/MainNav/MainNav";

export default function ProjectDetailsPage() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="Project Details" />
      <PageTop pageTitle="Project Details" />
      <ProjectDetails />
      <Footer />
    </>
  );
}
